// crm — see README.md. Keys must exist in BOTH maps (checked by npm run check:locales).
export const en = {
  // --- Booking reliability: holds let lapse, and the blacklist they add up to
  'crm.holds.title': 'Holds let go',
  'crm.holds.hint': 'tables held on the clock and never paid for',
  'crm.holds.last': 'last {when}',
  'crm.blacklist.badge': 'Blacklisted',
  'crm.blacklist.since': 'since {when}',
  'crm.blacklist.refused': 'Online bookings from this number are refused.',
  'crm.blacklist.lift': 'Lift blacklist',
  'crm.blacklist.liftHint': 'Lifting it also resets the strikes to zero.',
  'crm.blacklist.put': 'Blacklist this guest',
  'crm.blacklist.putHint': 'Refuses online bookings from this number until lifted.',
  'crm.blacklist.sure': 'Sure?',
  'crm.blacklist.yes': 'Yes',
  'crm.blacklist.no': 'No',
  'crm.blacklist.failed': 'Could not update the blacklist.',
  // --- Customer 360 profile page -------------------------------------------
  'crm.p.loading': 'Reading the guest…',
  'crm.p.loadFailed': 'Could not load this guest.',
  'crm.p.noteFailed': 'Could not save the note.',
  'crm.p.crumbCustomers': 'Customers',
  'crm.p.crumbAll': 'All customers',
  'crm.p.back': 'Back',
  'crm.p.openFull': 'Open full profile',
  'crm.p.profileBtn': 'Profile',
  'crm.p.memberSince': 'Member since {when}',
  'crm.p.guestId': 'Guest ID {id}',
  'crm.chip.tier': '{tier} member',
  'crm.chip.watchlist': 'Watchlist: {n} no-shows in 12 months',
  'crm.chip.lover': '{name} lover',
  'crm.chip.birthday': 'Birthday {date}',
  'crm.chip.whatsapp': 'WhatsApp opted in',
  'crm.p.noChips': 'Nothing noted about this guest yet.',
  'crm.p.removePref': 'Remove this preference',
  'crm.p.removeNote': 'Remove this note',
  'crm.p.newReservation': 'New reservation',
  'crm.p.sendWhatsapp': 'Send WhatsApp',
  'crm.p.addNote': 'Add note',
  'crm.p.blacklist': 'Blacklist',
  'crm.p.noteLabel': 'Note',
  'crm.p.notePlaceholder': 'Prefers window seating · allergic to peanuts · complained about noise on 3 Feb',
  'crm.p.kindNote': 'Diary note',
  'crm.p.kindPref': 'Preference',
  'crm.p.kindHint': 'A preference is printed as a chip beside the name on every screen; a diary note is read here.',
  'crm.p.saveNote': 'Save',
  'crm.p.notesTitle': 'Notes',
  'crm.p.behaviourTitle': 'Booking behaviour, last 12 months',
  'crm.p.behaviourSub': '{n} reservations across {locations} locations. Each block below is one booking.',
  'crm.p.behaviourNone': 'No resolved bookings in the last 12 months.',
  'crm.p.reliability': 'reliability score',
  'crm.p.adviceAdvance': 'advance recommended for parties of 4+',
  'crm.p.adviceNone': 'no advance needed',
  'crm.p.kind.honoured': 'Honoured',
  'crm.p.kind.no_show': 'Booked and didn’t show',
  'crm.p.kind.paid_no_show': 'Paid advance, didn’t show',
  'crm.p.kind.late_cancel': 'Cancelled after cut-off',
  'crm.p.kind.cancelled_ok': 'Cancelled in time',
  'crm.p.card.honoured': 'Honoured bookings',
  'crm.p.card.honouredSub': 'Showed up within hold time',
  'crm.p.card.noShow': 'Booked and didn’t show',
  'crm.p.card.noShowSub': 'Last: {date}, {location}',
  'crm.p.card.lateCancel': 'Cancelled after cut-off',
  'crm.p.card.lateCancelSub': 'Within {hours} h of the slot',
  'crm.p.card.lateCancelSubPlain': 'After the cancellation cut-off',
  'crm.p.card.paidNoShow': 'Paid advance, didn’t show',
  'crm.p.card.paidNoShowSub': '{amount} forfeited, {date}',
  'crm.p.card.cancelledOk': 'Cancelled in time',
  'crm.p.card.cancelledOkSub': 'Advance refunded',
  'crm.p.card.cancelledOkSubNone': 'No advance was due',
  'crm.p.card.none': '—',
  'crm.p.spendTitle': 'Spend and rhythm',
  'crm.p.visitsN': '{n} visits',
  'crm.p.avgBill': 'Average bill',
  'crm.p.everyDays': 'Every {n} days',
  'crm.p.visitFrequency': 'Visit frequency',
  'crm.p.perMonth': '{n} / month',
  'crm.p.lifetimeSpend': 'Lifetime spend',
  'crm.p.highestBill': 'Highest bill',
  'crm.p.usualParty': 'Usual party size',
  'crm.p.partyRange': '{a} to {b}',
  'crm.p.usualSlot': 'Usual slot',
  'crm.p.lastVisit': 'Last visit',
  'crm.p.nextReservation': 'Next reservation',
  'crm.p.noneBooked': 'None booked',
  'crm.p.dow.mon': 'Mon', 'crm.p.dow.tue': 'Tue', 'crm.p.dow.wed': 'Wed', 'crm.p.dow.thu': 'Thu',
  'crm.p.dow.fri': 'Fri', 'crm.p.dow.sat': 'Sat', 'crm.p.dow.sun': 'Sun',
  'crm.p.meal.breakfast': 'breakfast', 'crm.p.meal.lunch': 'lunch', 'crm.p.meal.dinner': 'dinner',
  'crm.p.dishesTitle': 'Repeat dishes',
  'crm.p.timesOrdered': 'times ordered',
  'crm.p.noDishes': 'No dishes ordered yet.',
  'crm.p.upsell': 'Suggested upsell: {item} (paired with {with} by {pct}% of similar guests).',
  'crm.p.placesTitle': 'Locations visited',
  'crm.p.visitsSpend': 'visits · spend',
  'crm.p.noPlaces': 'No visits recorded yet.',
  'crm.p.notVisited': 'Not yet visited: {names}.',
  'crm.p.homeBranch': 'Home branch is {name}.',
  'crm.p.loyaltyTitle': 'Loyalty rewards',
  'crm.p.points': '{n} points',
  'crm.p.redeemable': '≈ {amount} redeemable · {tier} since {since}',
  'crm.p.noLoyalty': 'No loyalty scheme yet — points, tiers and vouchers appear here once one is set up.',
  'crm.p.toNextTier': '{n} points to {tier}',
  'crm.p.noTier': 'No tier',
  'crm.p.tierResets': 'Tier resets {date}',
  'crm.p.earnedLifetime': 'Earned, lifetime',
  'crm.p.redeemed': 'Redeemed',
  'crm.p.expiring': 'Expiring {date}',
  'crm.p.expiringPlain': 'Expiring',
  'crm.p.referrals': 'Referrals',
  'crm.p.guestsN': '{n} guests',
  'crm.p.memberSaved': 'Member pricing saved',
  'crm.p.vouchersTitle': 'Active vouchers',
  'crm.p.noVouchers': 'No vouchers.',
  'crm.p.tabOrders': 'All orders',
  'crm.p.tabInvoices': 'Invoices',
  'crm.p.tabReservations': 'Reservations',
  'crm.p.showing': 'Showing last 12 months · all locations',
  'crm.p.noRows': 'Nothing in the last 12 months.',
  'crm.p.colOrder': 'Order',
  'crm.p.colInvoice': 'Invoice',
  'crm.p.colBooking': 'Booking',
  'crm.p.colDate': 'Date',
  'crm.p.colLocation': 'Location',
  'crm.p.colTable': 'Table',
  'crm.p.colStatus': 'Status',
  'crm.p.colAmount': 'Amount',
  'crm.p.colPax': 'Guests',
  'crm.p.colPayment': 'Payment',
  'crm.p.birthdayLabel': 'Birthday',
  'crm.p.whatsappLabel': 'WhatsApp opted in',
};

export const fr = {
  'crm.holds.title': 'Retenues abandonnées',
  'crm.holds.hint': 'tables retenues puis jamais payées',
  'crm.holds.last': 'dernière {when}',
  'crm.blacklist.badge': 'Liste noire',
  'crm.blacklist.since': 'depuis {when}',
  'crm.blacklist.refused': 'Les réservations en ligne de ce numéro sont refusées.',
  'crm.blacklist.lift': 'Retirer de la liste noire',
  'crm.blacklist.liftHint': 'Le retrait remet aussi les avertissements à zéro.',
  'crm.blacklist.put': 'Mettre sur liste noire',
  'crm.blacklist.putHint': 'Refuse les réservations en ligne de ce numéro jusqu’au retrait.',
  'crm.blacklist.sure': 'Confirmer ?',
  'crm.blacklist.yes': 'Oui',
  'crm.blacklist.no': 'Non',
  'crm.blacklist.failed': 'Impossible de mettre à jour la liste noire.',
  'crm.p.loading': 'Lecture de la fiche…',
  'crm.p.loadFailed': 'Impossible de charger ce client.',
  'crm.p.noteFailed': 'Impossible d’enregistrer la note.',
  'crm.p.crumbCustomers': 'Clients',
  'crm.p.crumbAll': 'Tous les clients',
  'crm.p.back': 'Retour',
  'crm.p.openFull': 'Ouvrir la fiche complète',
  'crm.p.profileBtn': 'Fiche',
  'crm.p.memberSince': 'Client depuis {when}',
  'crm.p.guestId': 'ID client {id}',
  'crm.chip.tier': 'Membre {tier}',
  'crm.chip.watchlist': 'À surveiller : {n} absences en 12 mois',
  'crm.chip.lover': 'Amateur de {name}',
  'crm.chip.birthday': 'Anniversaire {date}',
  'crm.chip.whatsapp': 'WhatsApp accepté',
  'crm.p.noChips': 'Rien de noté sur ce client pour l’instant.',
  'crm.p.removePref': 'Retirer cette préférence',
  'crm.p.removeNote': 'Retirer cette note',
  'crm.p.newReservation': 'Nouvelle réservation',
  'crm.p.sendWhatsapp': 'Envoyer un WhatsApp',
  'crm.p.addNote': 'Ajouter une note',
  'crm.p.blacklist': 'Liste noire',
  'crm.p.noteLabel': 'Note',
  'crm.p.notePlaceholder': 'Préfère une table près de la fenêtre · allergique aux arachides · s’est plaint du bruit le 3 fév.',
  'crm.p.kindNote': 'Note de journal',
  'crm.p.kindPref': 'Préférence',
  'crm.p.kindHint': 'Une préférence s’affiche en pastille à côté du nom sur chaque écran ; une note de journal se lit ici.',
  'crm.p.saveNote': 'Enregistrer',
  'crm.p.notesTitle': 'Notes',
  'crm.p.behaviourTitle': 'Comportement de réservation, 12 derniers mois',
  'crm.p.behaviourSub': '{n} réservations dans {locations} établissement(s). Chaque bloc ci-dessous est une réservation.',
  'crm.p.behaviourNone': 'Aucune réservation clôturée sur les 12 derniers mois.',
  'crm.p.reliability': 'score de fiabilité',
  'crm.p.adviceAdvance': 'acompte conseillé pour les tables de 4+',
  'crm.p.adviceNone': 'aucun acompte nécessaire',
  'crm.p.kind.honoured': 'Honorée',
  'crm.p.kind.no_show': 'Réservé sans venir',
  'crm.p.kind.paid_no_show': 'Acompte payé, absent',
  'crm.p.kind.late_cancel': 'Annulée après la limite',
  'crm.p.kind.cancelled_ok': 'Annulée à temps',
  'crm.p.card.honoured': 'Réservations honorées',
  'crm.p.card.honouredSub': 'Arrivé dans le délai de retenue',
  'crm.p.card.noShow': 'Réservé sans venir',
  'crm.p.card.noShowSub': 'Dernière : {date}, {location}',
  'crm.p.card.lateCancel': 'Annulée après la limite',
  'crm.p.card.lateCancelSub': 'Moins de {hours} h avant le créneau',
  'crm.p.card.lateCancelSubPlain': 'Après la limite d’annulation',
  'crm.p.card.paidNoShow': 'Acompte payé, absent',
  'crm.p.card.paidNoShowSub': '{amount} conservé, {date}',
  'crm.p.card.cancelledOk': 'Annulée à temps',
  'crm.p.card.cancelledOkSub': 'Acompte remboursé',
  'crm.p.card.cancelledOkSubNone': 'Aucun acompte dû',
  'crm.p.card.none': '—',
  'crm.p.spendTitle': 'Dépenses et rythme',
  'crm.p.visitsN': '{n} visites',
  'crm.p.avgBill': 'Addition moyenne',
  'crm.p.everyDays': 'Tous les {n} jours',
  'crm.p.visitFrequency': 'Fréquence des visites',
  'crm.p.perMonth': '{n} / mois',
  'crm.p.lifetimeSpend': 'Dépenses cumulées',
  'crm.p.highestBill': 'Addition la plus élevée',
  'crm.p.usualParty': 'Taille habituelle',
  'crm.p.partyRange': '{a} à {b}',
  'crm.p.usualSlot': 'Créneau habituel',
  'crm.p.lastVisit': 'Dernière visite',
  'crm.p.nextReservation': 'Prochaine réservation',
  'crm.p.noneBooked': 'Aucune',
  'crm.p.dow.mon': 'Lun', 'crm.p.dow.tue': 'Mar', 'crm.p.dow.wed': 'Mer', 'crm.p.dow.thu': 'Jeu',
  'crm.p.dow.fri': 'Ven', 'crm.p.dow.sat': 'Sam', 'crm.p.dow.sun': 'Dim',
  'crm.p.meal.breakfast': 'petit-déjeuner', 'crm.p.meal.lunch': 'déjeuner', 'crm.p.meal.dinner': 'dîner',
  'crm.p.dishesTitle': 'Plats récurrents',
  'crm.p.timesOrdered': 'fois commandé',
  'crm.p.noDishes': 'Aucun plat commandé pour l’instant.',
  'crm.p.upsell': 'Suggestion : {item} (associé à {with} par {pct} % des clients similaires).',
  'crm.p.placesTitle': 'Établissements visités',
  'crm.p.visitsSpend': 'visites · dépenses',
  'crm.p.noPlaces': 'Aucune visite enregistrée.',
  'crm.p.notVisited': 'Jamais visité : {names}.',
  'crm.p.homeBranch': 'Établissement habituel : {name}.',
  'crm.p.loyaltyTitle': 'Programme de fidélité',
  'crm.p.points': '{n} points',
  'crm.p.redeemable': '≈ {amount} utilisables · {tier} depuis {since}',
  'crm.p.noLoyalty': 'Pas encore de programme de fidélité — points, niveaux et bons apparaîtront ici une fois configurés.',
  'crm.p.toNextTier': '{n} points avant {tier}',
  'crm.p.noTier': 'Aucun niveau',
  'crm.p.tierResets': 'Niveau remis à zéro le {date}',
  'crm.p.earnedLifetime': 'Gagnés, cumulés',
  'crm.p.redeemed': 'Utilisés',
  'crm.p.expiring': 'Expirent le {date}',
  'crm.p.expiringPlain': 'Expirent',
  'crm.p.referrals': 'Parrainages',
  'crm.p.guestsN': '{n} clients',
  'crm.p.memberSaved': 'Économies tarif membre',
  'crm.p.vouchersTitle': 'Bons actifs',
  'crm.p.noVouchers': 'Aucun bon.',
  'crm.p.tabOrders': 'Toutes les commandes',
  'crm.p.tabInvoices': 'Factures',
  'crm.p.tabReservations': 'Réservations',
  'crm.p.showing': '12 derniers mois · tous les établissements',
  'crm.p.noRows': 'Rien sur les 12 derniers mois.',
  'crm.p.colOrder': 'Commande',
  'crm.p.colInvoice': 'Facture',
  'crm.p.colBooking': 'Réservation',
  'crm.p.colDate': 'Date',
  'crm.p.colLocation': 'Établissement',
  'crm.p.colTable': 'Table',
  'crm.p.colStatus': 'Statut',
  'crm.p.colAmount': 'Montant',
  'crm.p.colPax': 'Convives',
  'crm.p.colPayment': 'Paiement',
  'crm.p.birthdayLabel': 'Anniversaire',
  'crm.p.whatsappLabel': 'WhatsApp accepté',
};
